export default (theme) => ({
  container: {
    padding: 20,
    marginLeft: "auto",
    marginRight: "auto",
  },
});
